import React from 'react';
import Link from 'next/link';
import { DataTestIds } from 'src/config/dataTestIds';
import SettingsMenu from '../SettingsMenu';
import SideBarMenu from '../SideBarMenu';
import * as S from './AppBar.styles';
const AppBar = () => /*#__PURE__*/React.createElement(S.AppBar, {
  leftContent: /*#__PURE__*/React.createElement(SideBarMenu, null),
  middleContent: /*#__PURE__*/React.createElement(Link, {
    href: "/",
    passHref: true,
    "data-testid": DataTestIds.HeaderLogo
  }, /*#__PURE__*/React.createElement(S.Logo, null)),
  rightContent: /*#__PURE__*/React.createElement(SettingsMenu, null)
});
export default AppBar;